import '@pj/base/scss/base.scss';
import Utils from '@core/base/scripts/utils/utils';
import $ from 'jquery';
import 'picturefill';
import GlossaryTooltip from "@core/components/glossary-tooltip/glossary-tooltip";
import ScrollHandler from '@core/base/scripts/classes/ScrollHandler';

Utils.vhFix();

$('body').toggleClass('ie', Utils.isIE);
$('body').toggleClass('edge', Utils.isEdge);

const hash = window.location.hash.substr(1);
if (hash) {
  Utils.goToHash(hash);
}

$(document).ready(function () {
  const scrollHandler = new ScrollHandler();
  scrollHandler.init();
  //
  const tooltip = new GlossaryTooltip(scrollHandler);
  tooltip.init();

  scrollHandler.onScroll(() => {
    tooltip.cleanup();
  });
})
